import request from '@/utils/request'

let Api = {
  /*小程序*/
  getData(data) {
    return request._get('/shop/plus.api.app/index', data);
  },
  applyData(data) {
    return request._post('/shop/plus.api.app/index', data);
  },

}

export default Api;



// WEBPACK FOOTER //
// ./src/api/api.js